import {
  initialState,
  Actions,
  State,
  SELECT_ONE_PREJUDICIAL,
  SELECT_ONE_PREJUDICIAL_SUCCESS,
  SELECT_ONE_PREJUDICIAL_ERROR,
  RESET_SELECT_ONE_PREJUDICIAL,
} from "../../types/prejudicial/selectOne";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SELECT_ONE_PREJUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case SELECT_ONE_PREJUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case SELECT_ONE_PREJUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_SELECT_ONE_PREJUDICIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
